import { render, staticRenderFns } from "./DietPage.vue?vue&type=template&id=7e7aeb68&scoped=true&"
import script from "./DietPage.vue?vue&type=script&lang=js&"
export * from "./DietPage.vue?vue&type=script&lang=js&"
import style0 from "./DietPage.vue?vue&type=style&index=0&id=7e7aeb68&scoped=true&lang=scss&"
import style1 from "./DietPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7aeb68",
  null
  
)

export default component.exports